import { useNavigate } from 'react-router-dom';
import BobineLogo from '../components/BobineLogo';
import ServicesDropdown from '../components/ServicesDropdown';
import MobileNav from '../components/MobileNav';

const serif = "'Georgia', 'Times New Roman', serif";

const ServicesPage = () => {
  const navigate = useNavigate();
  const isLoggedIn = !!localStorage.getItem('bobine_token');

  const services = [
    {
      id: 'numerisation',
      title: 'Numérisation de vos Archives',
      subtitle: 'Service physique — Gants de soie & suivi sécurisé',
      description:
        'Confiez-nous vos albums, tirages papier, négatifs et diapositives. Notre conservateur numérise chaque souvenir avec un soin muséal : gants de soie, nettoyage expert, suivi GPS sécurisé et assurance tous risques.',
      price: '49',
      priceLabel: 'À partir de',
      priceSuffix: '€',
      features: [
        "3 kits au choix : L'Écrin, Le Coffret, La Malle",
        'Numérisation haute résolution (600 DPI)',
        'Nettoyage professionnel de chaque document',
        'Suivi GPS en temps réel de vos archives',
        'Assurance tous risques incluse',
      ],
      cta: 'Découvrir les kits',
      path: '/numerisation',
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
          <line x1="8" y1="21" x2="16" y2="21" />
          <line x1="12" y1="17" x2="12" y2="21" />
        </svg>
      ),
    },
    {
      id: 'livres',
      title: "Livres Photo d'Art",
      subtitle: 'Lin · Cuir · Soie — Imprimés à la demande',
      description:
        "Transformez vos Trésors en un livre d'exception. Chaque ouvrage est relié à la main avec des matériaux nobles : couverture en lin naturel, cuir grainé avec dorure, ou soie brodée main avec tranche dorée à la feuille d'or.",
      price: '49',
      priceLabel: 'À partir de',
      priceSuffix: '€',
      features: [
        "3 finitions : L'Essentiel (Lin), La Chronique (Cuir), Le Grand Récit (Soie)",
        'De 30 à 200 photos par livre',
        'Papier photo premium 200g à 250g',
        'Coffret ou écrin luxe inclus',
        '-20% pour les abonnés Héritage',
      ],
      cta: 'Créer mon Livre',
      path: '/livre-photo',
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 19.5A2.5 2.5 0 016.5 17H20" />
          <path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" />
        </svg>
      ),
    },
    {
      id: 'restauration',
      title: 'Restauration IA Renaissance',
      subtitle: 'Intelligence Artificielle — Résultats instantanés',
      description:
        'Notre IA redonne vie à vos photos numériques : couleurs restaurées, netteté retrouvée, rayures effacées. Disponible à l\'unité ou en pack de 10 avec 20% d\'économie. Inclus en illimité dans l\'offre Héritage.',
      price: '0,99',
      priceLabel: 'À partir de',
      priceSuffix: '€ /photo',
      features: [
        'Restauration à l\'unité : 0,99€ par photo',
        'Pack Renaissance (10 photos) : 7,99€ — Économisez 20%',
        'Correction des couleurs et de la netteté',
        'Suppression des rayures et imperfections',
        'Inclus en illimité avec l\'offre Héritage',
      ],
      cta: 'Restaurer mes photos',
      path: '/offres',
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 3a9 9 0 0 0-9 9h3l-4 4-4-4h3a11 11 0 0 1 11-11z" />
          <path d="M12 21a9 9 0 0 0 9-9h-3l4-4 4 4h-3a11 11 0 0 1-11 11z" />
        </svg>
      ),
    },
  ];

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#000' }}>
      <style>{`
        @keyframes bobineGlow {
          0%, 100% { filter: drop-shadow(0 0 8px rgba(212,175,55,0.3)); }
          50% { filter: drop-shadow(0 0 20px rgba(212,175,55,0.7)) drop-shadow(0 0 40px rgba(212,175,55,0.2)); }
        }
        @keyframes bobineSpin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
      `}</style>
      {/* Header */}
      <header style={{ borderBottom: '1px solid rgba(212,175,55,0.2)' }}>
        <div className="container mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <BobineLogo size={22} />
          <div className="hidden md:flex items-center gap-3">
            <ServicesDropdown />
            <button
              onClick={() => navigate(isLoggedIn ? '/dashboard' : '/compte')}
              data-testid="services-cta-login"
              style={{
                fontFamily: serif, fontSize: 12, padding: '6px 14px', borderRadius: 6,
                cursor: 'pointer', background: 'linear-gradient(145deg, #D4AF37, #B8860B)', color: '#000',
                border: 'none', fontWeight: 600,
              }}
            >
              {isLoggedIn ? 'Mon Coffre-fort' : 'Commencer'}
            </button>
          </div>
          <MobileNav
            items={[
              { label: 'Retour', action: () => navigate(-1) },
              { label: 'Accueil', action: () => navigate('/') },
              { label: 'Nos Offres', action: () => navigate('/offres') },
              { label: isLoggedIn ? 'Mon Coffre-fort' : 'Commencer', action: () => navigate(isLoggedIn ? '/dashboard' : '/compte') },
            ]}
          />
        </div>
      </header>

      <main className="container mx-auto px-4 sm:px-6 py-12 sm:py-16 max-w-5xl">
        {/* Back button */}
        <div style={{ marginBottom: 24 }}>
          <button
            onClick={() => navigate(-1)}
            data-testid="back-btn"
            style={{
              fontFamily: serif, fontSize: 14, padding: '10px 20px', borderRadius: 8,
              cursor: 'pointer', color: '#D4AF37',
              backgroundColor: 'rgba(212,175,55,0.08)',
              border: '1px solid rgba(212,175,55,0.3)',
              display: 'flex', alignItems: 'center', gap: 6,
              fontWeight: 500, transition: 'all 0.3s',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = 'rgba(212,175,55,0.15)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'rgba(212,175,55,0.08)'; }}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <polyline points="15 18 9 12 15 6" />
            </svg>
            Retour
          </button>
        </div>

        {/* Hero */}
        <div className="text-center" style={{ marginBottom: 64 }}>
          <div style={{ marginBottom: 20 }}>
            <img
              src="/bobine-face-logo.png"
              alt=""
              style={{
                width: 56, height: 56, objectFit: 'contain', margin: '0 auto',
                animation: 'bobineGlow 3s ease-in-out infinite, bobineSpin 30s linear infinite',
              }}
            />
          </div>
          <h1
            data-testid="services-title"
            style={{
              fontFamily: serif, fontSize: 36, color: '#D4AF37',
              marginBottom: 16, letterSpacing: 1, fontWeight: 400,
            }}
          >
            Services de Prestige
          </h1>
          <p
            style={{
              fontFamily: serif, fontSize: 16, color: '#FAF3E0',
              lineHeight: 1.8, maxWidth: 560, margin: '0 auto',
            }}
          >
            Au-delà du coffre-fort numérique, Bobine vous offre un écrin de services
            d'exception pour sublimer, préserver et transmettre vos souvenirs les plus précieux.
          </p>
        </div>

        {/* Services Grid */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 32 }}>
          {services.map((service, index) => (
            <div
              key={service.id}
              data-testid={`service-card-${service.id}`}
              style={{
                border: '1px solid rgba(212,175,55,0.2)',
                borderRadius: 16,
                backgroundColor: 'rgba(212,175,55,0.015)',
                overflow: 'hidden',
                transition: 'all 0.4s',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = '#D4AF37';
                e.currentTarget.style.backgroundColor = 'rgba(212,175,55,0.03)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = '#D4AF37';
                e.currentTarget.style.backgroundColor = 'rgba(212,175,55,0.015)';
              }}
            >
              <div
                className="flex flex-col md:flex-row"
                style={{ minHeight: 280 }}
              >
                {/* Left: Info */}
                <div
                  style={{
                    flex: 1, padding: '36px 32px',
                    display: 'flex', flexDirection: 'column', justifyContent: 'center',
                    order: index % 2 === 1 ? 2 : 1,
                  }}
                >
                  <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 14 }}>
                    <div
                      style={{
                        width: 56, height: 56, borderRadius: 14,
                        backgroundColor: 'rgba(212,175,55,0.06)',
                        border: '1px solid rgba(212,175,55,0.15)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0,
                      }}
                    >
                      {service.icon}
                    </div>
                    <div>
                      <h2
                        style={{
                          fontFamily: serif, fontSize: 22, color: '#D4AF37',
                          fontWeight: 400, margin: 0, letterSpacing: 0.5,
                        }}
                      >
                        {service.title}
                      </h2>
                      <p
                        style={{
                          fontFamily: serif, fontSize: 12,
                          color: '#D4AF37',
                          margin: '4px 0 0', fontStyle: 'italic', letterSpacing: 0.3,
                        }}
                      >
                        {service.subtitle}
                      </p>
                    </div>
                  </div>

                  <p
                    style={{
                      fontFamily: serif, fontSize: 14, color: '#FAF3E0',
                      lineHeight: 1.7, marginBottom: 20,
                    }}
                  >
                    {service.description}
                  </p>

                  <button
                    onClick={() => navigate(service.path)}
                    data-testid={`cta-${service.id}`}
                    style={{
                      fontFamily: serif, fontSize: 14, fontWeight: 600,
                      padding: '13px 32px', borderRadius: 8,
                      cursor: 'pointer', transition: 'all 0.3s',
                      background: 'linear-gradient(145deg, #D4AF37, #B8860B)', color: '#000',
                      border: 'none',
                      boxShadow: '0 4px 20px rgba(212,175,55,0.25)',
                      alignSelf: 'flex-start',
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-1px)'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; }}
                  >
                    {service.cta}
                  </button>
                </div>

                {/* Right: Features + Price */}
                <div
                  style={{
                    width: '100%', maxWidth: 340, padding: '36px 28px',
                    backgroundColor: 'rgba(212,175,55,0.025)',
                    borderLeft: '1px solid rgba(212,175,55,0.1)',
                    display: 'flex', flexDirection: 'column', justifyContent: 'center',
                    order: index % 2 === 1 ? 1 : 2,
                  }}
                  className="md:max-w-[340px]"
                >
                  {/* Price badge */}
                  <div style={{ textAlign: 'center', marginBottom: 24 }}>
                    <span style={{ fontFamily: serif, fontSize: 12, color: '#D4AF37' }}>
                      {service.priceLabel}{' '}
                    </span>
                    <span style={{ fontFamily: serif, fontSize: 36, fontWeight: 500, color: '#D4AF37' }}>
                      {service.price}
                    </span>
                    <span style={{ fontFamily: serif, fontSize: 14, color: '#D4AF37' }}>
                      {service.priceSuffix}
                    </span>
                  </div>

                  {/* Features list */}
                  <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                    {service.features.map((feature, i) => (
                      <li
                        key={i}
                        style={{
                          display: 'flex', alignItems: 'flex-start', gap: 10,
                          marginBottom: 10,
                        }}
                      >
                        <span style={{ color: '#D4AF37', fontSize: 11, marginTop: 3, flexShrink: 0 }}>&#10003;</span>
                        <span
                          style={{
                            fontFamily: serif, fontSize: 12,
                            color: '#FAF3E0', lineHeight: 1.5,
                          }}
                        >
                          {feature}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div
          style={{
            textAlign: 'center', marginTop: 64, padding: '40px 24px',
            borderRadius: 16,
            background: 'linear-gradient(135deg, rgba(212,175,55,0.06), rgba(212,175,55,0.02))',
            border: '1px solid rgba(212,175,55,0.15)',
          }}
        >
          <img
            src="/bobine-reel-transparent.png"
            alt=""
            style={{
              width: 32, height: 32, objectFit: 'contain', margin: '0 auto 16px',
              filter: 'drop-shadow(0 0 8px rgba(212,175,55,0.3))',
            }}
          />
          <h3
            style={{
              fontFamily: serif, fontSize: 20, color: '#D4AF37',
              fontWeight: 400, marginBottom: 8, letterSpacing: 0.5,
            }}
          >
            Une question sur nos services ?
          </h3>
          <p
            style={{
              fontFamily: serif, fontSize: 14, color: '#FAF3E0',
              marginBottom: 24, lineHeight: 1.7,
            }}
          >
            Notre équipe est à votre disposition pour vous accompagner
            dans la préservation de vos souvenirs.
          </p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <a
              href="mailto:bonjour@bobine.live"
              data-testid="services-contact-email"
              style={{
                fontFamily: serif, fontSize: 14, fontWeight: 600,
                padding: '13px 32px', borderRadius: 8,
                cursor: 'pointer', transition: 'all 0.3s',
                background: 'linear-gradient(145deg, #D4AF37, #B8860B)', color: '#000',
                border: 'none', textDecoration: 'none',
                boxShadow: '0 4px 20px rgba(212,175,55,0.25)',
              }}
            >
              Nous contacter
            </a>
            <button
              onClick={() => navigate('/offres')}
              data-testid="services-see-plans"
              style={{
                fontFamily: serif, fontSize: 14,
                padding: '13px 32px', borderRadius: 8,
                cursor: 'pointer', transition: 'all 0.3s',
                backgroundColor: 'transparent', color: '#D4AF37',
                border: '1px solid rgba(212,175,55,0.4)',
              }}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = 'rgba(212,175,55,0.08)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
            >
              Voir nos abonnements
            </button>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer style={{ borderTop: '1px solid rgba(212,175,55,0.15)', marginTop: 64, padding: '24px 0' }}>
        <div className="text-center">
          <BobineLogo size={14} />
          <p style={{ fontFamily: serif, color: '#D4AF37', fontSize: 11, marginTop: 4 }}>
            Une création Coup de Projet
          </p>
          <div style={{ marginTop: 12, display: 'flex', gap: 16, justifyContent: 'center' }}>
            <a href="/terms" style={{ fontFamily: serif, fontSize: 11, color: '#D4AF37', textDecoration: 'none' }}>CGU</a>
            <a href="/privacy" style={{ fontFamily: serif, fontSize: 11, color: '#D4AF37', textDecoration: 'none' }}>Confidentialité</a>
            <a href="mailto:bonjour@bobine.live" style={{ fontFamily: serif, fontSize: 11, color: '#D4AF37', textDecoration: 'none' }}>Contact</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ServicesPage;
